import React from "react";
import { CreditCard, Battery, RotateCcw } from "lucide-react";

const HowItWorks = () => {
  const steps = [
    {
      icon: CreditCard,
      number: "01",
      title: "Betal",
      description: "Skann QR-koden og betal enkelt med Vipps eller kort",
    },
    {
      icon: Battery,
      number: "02",
      title: "Ta powerbank",
      description: "Hent ut en fulladet powerbank fra stasjonen",
    },
    {
      icon: RotateCcw,
      number: "03",
      title: "Lever tilbake",
      description: "Lever tilbake til hvilken som helst B-Labs stasjon",
    },
  ];

  return (
    <section
      id="how-it-works"
      className="py-24 md:py-32 bg-[#0A0A0A]"
      data-testid="how-it-works-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        {/* Section Header */}
        <div className="text-center mb-16 md:mb-20">
          <span className="text-xs tracking-[0.2em] uppercase font-bold text-[#FFD84D] mb-4 block">
            Enkelt og raskt
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-white font-['Outfit']">
            Slik fungerer det
          </h2>
        </div>

        {/* Steps Grid */}
        <div className="grid md:grid-cols-3 gap-8 stagger-children">
          {steps.map((step, index) => (
            <div
              key={index}
              className="relative bg-[#121212] border border-white/5 rounded-2xl p-8 md:p-10 card-hover group"
              data-testid={`step-${index + 1}`}
            >
              {/* Step Number */}
              <span className="absolute top-6 right-6 text-6xl font-bold text-white/5 font-['Outfit']">
                {step.number}
              </span>

              {/* Icon */}
              <div className="icon-wrapper mb-6 group-hover:shadow-[0_0_20px_rgba(255,216,77,0.3)] transition-all">
                <step.icon className="w-7 h-7 text-[#FFD84D]" />
              </div>

              {/* Content */}
              <h3 className="text-2xl font-semibold text-white mb-3 font-['Outfit']">
                {step.title}
              </h3>
              <p className="text-[#A1A1AA] leading-relaxed">
                {step.description}
              </p>

              {/* Connector Line (hidden on last item and mobile) */}
              {index < steps.length - 1 && (
                <div className="hidden md:block absolute top-1/2 -right-4 w-8 h-[2px] bg-gradient-to-r from-[#FFD84D]/50 to-transparent" />
              )}
            </div>
          ))}
        </div>

        {/* User charging image */}
        <div className="mt-16 md:mt-24 flex justify-center">
          <div className="relative max-w-2xl">
            <div className="absolute inset-0 bg-[#FFD84D]/10 blur-3xl rounded-full" />
            <img
              src="https://static.prod-images.emergentagent.com/jobs/34039477-a207-4dc8-98b5-a0f0d25d9137/images/f31cc6232a0f8b6a4514de296d2a2bf10375beba046f8b0ffde5b0999436455b.png"
              alt="Person bruker B-Labs powerbank"
              className="relative z-10 w-full rounded-2xl shadow-2xl"
              data-testid="how-it-works-image"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
